var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PeerMetrics } from '@peermetrics/sdk';
var getPeerConnectionFromTransport = function (transport) {
    var _a;
    if (!transport || typeof transport !== 'object') {
        return null;
    }
    if (transport instanceof RTCPeerConnection) {
        return transport;
    }
    var candidate = (_a = transport._pc) !== null && _a !== void 0 ? _a : transport.pc;
    if (candidate && typeof candidate === 'object') {
        return candidate;
    }
    return null;
};
var PeerMetricsManager = /** @class */ (function () {
    function PeerMetricsManager(roomCode, room, serverHost) {
        this.roomCode = roomCode;
        this.room = room;
        this.serverHost = serverHost;
        this.peerMetrics = null;
        this.listenerCleanup = null;
        this.connections = {
            publisher: undefined,
            subscriber: undefined,
        };
    }
    PeerMetricsManager.prototype.ensureSession = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var apiKey, normalizedRole, peerMetrics, error_1, engine, handleTransportsCreated, pcManager;
            var _this = this;
            var _c, _d;
            var userId = _b.userId, userName = _b.userName, role = _b.role;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (typeof window === 'undefined') {
                            return [2 /*return*/];
                        }
                        apiKey = import.meta.env.VITE_REACT_APP_PEERMETRICS_API_KEY;
                        if (!apiKey) {
                            console.warn('PeerMetrics API key is not configured, skipping instrumentation');
                            return [2 /*return*/];
                        }
                        if (!!this.peerMetrics) return [3 /*break*/, 4];
                        normalizedRole = typeof role === 'string' ? role : role !== undefined && role !== null ? String(role) : undefined;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        peerMetrics = new PeerMetrics({
                            apiKey: apiKey,
                            apiRoot: import.meta.env.VITE_REACT_APP_PEERMETRICS_API_ROOT,
                            userId: userId,
                            userName: userName,
                            conferenceId: this.roomCode,
                            conferenceName: this.roomCode,
                            meta: normalizedRole ? { role: normalizedRole } : undefined,
                        });
                        return [4 /*yield*/, peerMetrics.initialize()];
                    case 2:
                        _e.sent();
                        this.peerMetrics = peerMetrics;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _e.sent();
                        console.error('Failed to initialize PeerMetrics', error_1);
                        this.peerMetrics = null;
                        return [2 /*return*/];
                    case 4:
                        if (this.listenerCleanup) {
                            return [2 /*return*/];
                        }
                        engine = (_c = this.room) === null || _c === void 0 ? void 0 : _c.engine;
                        if (!engine) {
                            console.warn('LiveKit engine is not ready, skipping PeerMetrics setup for now');
                            return [2 /*return*/];
                        }
                        void this.updateServerAddress();
                        handleTransportsCreated = function (publisher, subscriber) {
                            void _this.registerTransport(publisher, 'publisher');
                            void _this.registerTransport(subscriber, 'subscriber');
                        };
                        (_d = engine.on) === null || _d === void 0 ? void 0 : _d.call(engine, 'transportsCreated', handleTransportsCreated);
                        this.listenerCleanup = function () {
                            var _a;
                            (_a = engine.off) === null || _a === void 0 ? void 0 : _a.call(engine, 'transportsCreated', handleTransportsCreated);
                        };
                        pcManager = engine.pcManager;
                        if (pcManager === null || pcManager === void 0 ? void 0 : pcManager.publisher) {
                            void this.registerTransport(pcManager.publisher, 'publisher');
                        }
                        if (pcManager === null || pcManager === void 0 ? void 0 : pcManager.subscriber) {
                            void this.registerTransport(pcManager.subscriber, 'subscriber');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PeerMetricsManager.prototype.cleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var peerMetrics, removals, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.listenerCleanup) === null || _a === void 0 ? void 0 : _a.call(this);
                        this.listenerCleanup = null;
                        peerMetrics = this.peerMetrics;
                        if (!peerMetrics) {
                            this.connections = {
                                publisher: undefined,
                                subscriber: undefined,
                            };
                            return [2 /*return*/];
                        }
                        removals = [];
                        Object.values(this.connections).forEach(function (connection) {
                            if (connection === null || connection === void 0 ? void 0 : connection.connectionId) {
                                removals.push(peerMetrics.removeConnection({ connectionId: connection.connectionId }).catch(function (error) {
                                    console.warn('Failed to remove PeerMetrics connection', error);
                                }));
                            }
                        });
                        this.connections = {
                            publisher: undefined,
                            subscriber: undefined,
                        };
                        if (!removals.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(removals)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, 5, 6]);
                        return [4 /*yield*/, peerMetrics.endCall()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _b.sent();
                        console.warn('Failed to end PeerMetrics session', error_2);
                        return [3 /*break*/, 6];
                    case 5:
                        this.peerMetrics = null;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PeerMetricsManager.prototype.registerTransport = function (transport, key) {
        return __awaiter(this, void 0, void 0, function () {
            var peerConnection, existingConnection, error_3, peerId, peerName, connectionId, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.peerMetrics || !transport) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.updateServerAddress()];
                    case 1:
                        _a.sent();
                        peerConnection = getPeerConnectionFromTransport(transport);
                        if (!peerConnection) {
                            console.warn("Unable to resolve RTCPeerConnection for ".concat(key, " transport"));
                            return [2 /*return*/];
                        }
                        existingConnection = this.connections[key];
                        if (!(existingConnection === null || existingConnection === void 0 ? void 0 : existingConnection.connectionId)) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.peerMetrics.removeConnection({ connectionId: existingConnection.connectionId })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        console.warn("Failed to remove existing PeerMetrics connection for ".concat(key), error_3);
                        return [3 /*break*/, 5];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        peerId = "".concat(this.roomCode, "-").concat(key);
                        peerName = this.buildPeerName(key);
                        return [4 /*yield*/, this.peerMetrics.addConnection({
                                peerId: peerId,
                                peerName: peerName,
                                pc: peerConnection,
                                isSfu: true,
                                remote: true,
                            })];
                    case 6:
                        connectionId = (_a.sent()).connectionId;
                        this.connections[key] = {
                            connectionId: connectionId,
                            peerId: peerId,
                        };
                        return [3 /*break*/, 8];
                    case 7:
                        error_4 = _a.sent();
                        console.error("Failed to register ".concat(key, " transport with PeerMetrics"), error_4);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    PeerMetricsManager.prototype.buildPeerName = function (key) {
        var fallback = key === 'publisher' ? 'LiveKit Publisher' : 'LiveKit Subscriber';
        var base = this.serverHost || fallback;
        if (this.serverAddress) {
            return "".concat(base, " (").concat(this.serverAddress, ")");
        }
        return base;
    };
    PeerMetricsManager.prototype.updateServerAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var engine, address, error_5;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.serverAddress) {
                            return [2 /*return*/];
                        }
                        engine = (_a = this.room) === null || _a === void 0 ? void 0 : _a.engine;
                        if (!(engine === null || engine === void 0 ? void 0 : engine.getConnectedServerAddress)) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, engine.getConnectedServerAddress()];
                    case 2:
                        address = _b.sent();
                        if (address) {
                            this.serverAddress = address;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _b.sent();
                        console.warn('Failed to resolve LiveKit server address', error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return PeerMetricsManager;
}());
export { PeerMetricsManager };
//# sourceMappingURL=data:application/json;base64,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